/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S10_Li1Inputs */

const tr_mesafeli_s10_li1 = /** @type {(inputs: Mesafeli_S10_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AES-256-GCM algoritması ile şifrelenerek Supabase Postgres veritabanında saklanır. Şifre çözme anahtarı Cloudflare Secrets Store üzerinde tutulur.`)
};

const en_mesafeli_s10_li1 = /** @type {(inputs: Mesafeli_S10_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`is stored encrypted with the AES-256-GCM algorithm in the Supabase Postgres database. The decryption key is kept in the Cloudflare Secrets Store.`)
};

const de_mesafeli_s10_li1 = /** @type {(inputs: Mesafeli_S10_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`werden mit dem Algorithmus AES-256-GCM verschlüsselt in der Supabase-Postgres-Datenbank gespeichert. Der Entschlüsselungsschlüssel wird im Cloudflare Secrets Store verwahrt.`)
};

const ru_mesafeli_s10_li1 = /** @type {(inputs: Mesafeli_S10_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`хранятся в базе данных Supabase Postgres в зашифрованном виде по алгоритму AES-256-GCM. Ключ расшифровки хранится в Cloudflare Secrets Store.`)
};

/**
* | output |
* | --- |
* | "is stored encrypted with the AES-256-GCM algorithm in the Supabase Postgres database. The decryption key is kept in the Cloudflare Secrets Store." |
*
* @param {Mesafeli_S10_Li1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s10_li1 = /** @type {((inputs?: Mesafeli_S10_Li1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S10_Li1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s10_li1(inputs)
	if (locale === "de") return de_mesafeli_s10_li1(inputs)
	if (locale === "ru") return ru_mesafeli_s10_li1(inputs)
	return tr_mesafeli_s10_li1(inputs)
});